<template>
  <div class="about">
    <h1>{{ msg }}</h1>


<h2>会社概要</h2>

<table>

<tr>
<th>
商号
</th>
<td>
株式会社 HIRO ICT研究所
</td>
</tr>
<tr>
<tr>
<th>
役員
</th>
<td>
代表取締役 樋口 雅宏
</td>
</tr>
<tr>
<th>
所在地
</th>
<td>
〒231-0033 横浜市中区長者町5-49-1 ラフィーヌ長者町ビル501
<br>（市営地下鉄伊勢佐木長者駅出口6B前）
<p style="text-align:center;"><img src="http://www.hiroict.com/img/hiro_ict/ラフィーヌ長者町ビル.png"><br>ラフィーヌ長者町ビル（中央のビル）</p>
</td>
</tr>
<tr>
<th>
電話番号
</th>
<td>
090-8843-4760（代表取締役 樋口 雅宏）<br>
090-3698-2571（取締役 渡辺 透）
</td>
</tr>
<tr>
<th>
FAX
</th>
<td>
なし
</td>
</tr>
<tr>
<th>
メール
</th>
<td>
<a href="mailto:higuchi.hiroict@gmail.com">higuchi.hiroict@gmail.com</a>
</td>
</tr>
<tr>
<th>
資本金
</th>
<td>
1,000万円
</td>
</tr>
<tr>
<th>
営業時間
</th>
<td>
月～土  9：00～17：30
<br>（日、祝日、お盆、年末年始は休み）
</td>
</tr>
<tr>
<th>
所属団体（法人）
</th>
<td>
<p>
NPO法人M2M研究会
</p>
</td>
</tr>
</table>


  </div>

</template>

<script>
import Vue from 'vue'
import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

export default {
  name: 'AboutWorld',
  props: {
    msg: String
  },
  data() {
    return {
      //videoId1: 'mfhGUK13D3g',
      //videoId2: 'ibuWJv6ncDg',
      //videoId3: '-DBmZqeww0E',
      
      //comments_1: {
      //  title: 'トークA愛の特徴',
      //  items:[
      //         '「トークA愛」は、独居高齢者のためのお友達です。',
      //         '「トークA愛」は、独居高齢者を見守る人のためのお友達です。',
      //        ],
      //}, // end of comments_1
      /*
      comments_2: {
        title: 'トークA愛の機器構成例',
        items:[
               '「Google Nest Hub Max」は、居間に設置します。',
               '「Google Nest Mini」は、「洗面所」と「トイレ」に設置します。',
               '「Google Chromecast」は、「テレビ」にHDMIインターフェイスで接続します。',
               '「Androidタブレット」は、「Google Nest Hub Max」「Google Nest Mini」「Google Chromecast」の設定を行います。',
              ],
      }, // end of comments_2

      comments_3: {
        title: 'トークA愛の利用例（独居高齢者）',
        items:[
               '居間に設置された「Google Nest Hub Max」で、「写真」「音楽」「動画」を楽しむ事ができます。',
               'オプションで「Google Nest Hub Max」で、孫など家族や友人と「テレビ電話」を楽しむ事ができます。',
               'オプションで「Google Nest Hub Max」の画面を「Google Chromecast」で「テレビ」に表示することができます。',
               'オプションで「Google Nest Hub Max」から、その時間になると「スケジュール情報」などを音声で聞くことができます。',
               '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、「緊急電話」をすることができます。',
              ],
      }, // end of comments_3

      comments_4: {
        title: 'トークA愛の利用例（介護者）',
        items:[
               '「Google Nest Hub Max」が独居高齢者をカメラと音声で見守りをする事ができます。',
               '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、独居高齢者と「緊急電話」をすることができます。',
               'オプションで人感センサー「M5StickC PIR HAT」を使用して、独居高齢者の居場所を把握する事ができます。',
              ],
      }, // end of comments_4

      comments: [],
      */
    } // end of return
  }, // end of data()
  
  created () {
    this.comments = [this.comments_1, this.comments_2, this.comments_3, this.comments_4]
    //this.firstVideo()
  },
  
} // end of default
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  //display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table {
	border: 1px #E3E3E3 solid;
	border-collapse: collapse;
	border-spacing: 0;
}

table th {
	padding: 5px;
	border: #E3E3E3 solid;
	border-width: 0 0 1px 1px;
	background-color: #C0C0F0;
	font-weight: bold;
	line-height: 120%;
	text-align: center;
}
table td {
	padding: 5px;
	border: 1px #E3E3E3 solid;
	border-width: 0 0 1px 1px;
	background-color: #F5F5F5;
	text-align: left;
}

</style>
